import React, { useEffect, useState } from "react";
import axios from "axios";

import ShowItem from "./ShowItem";
const EventList = () => {
  const [events, setEvents] = useState([]);

  const [pastEvents, setPastEvents] = useState([]); // NEW
  useEffect(() => {
    const fetchEvents = async () => {
      try {
        // Replace with your own Google Sheets ID and Sheet Name
        // https://docs.google.com/spreadsheets/d/1ElCurAUvGDkKL7uVQG9zpeC1-ROOmJZyVLaWkQ7h4vg/edit?usp=sharing
        const sheetId = "1ElCurAUvGDkKL7uVQG9zpeC1-ROOmJZyVLaWkQ7h4vg";
        const sheetName = "Sheet 1";
        const pastSheetName = "Previous Dates";
        const upcoming = await axios.get(
          `https://opensheet.vercel.app/${sheetId}/${sheetName}`
        );
        const past = await axios.get(
          `https://opensheet.vercel.app/${sheetId}/${pastSheetName}`
        );
        setEvents(upcoming.data);
        setPastEvents(past.data.reverse());
      } catch (error) {
        console.error("Error fetching events data:", error);
      }
    };

    fetchEvents();
  }, []);

  return (
    <section
      id="shows"
      className="events uk-section"
      data-uk-scrollspy="cls:uk-animation-fade; offset-top: 80px; delay: 300"
    >
      <div className="container--min uk-container">
        <h2 className="uk-h2 uk-margin-bottom">Shows</h2>
        {/* <span href="" className="uk-text-right btn btn--disabled">
          <h5 className="uk-text-right uk-text-warning disabled">
            Full Performance History <br></br>
            <span className="uk-h5">*Coming soon</span>
          </h5>
        </span> */}

        <ul className="uk-tab" data-uk-switcher="{connect: #shows-switcher}">
          <li className="uk-active">
            <a  href="#">Upcoming</a>
          </li>
          <li>
            <a  href="#">Past</a>
          </li>
        </ul>
        <ul id="shows-swticher" className="uk-switcher uk-margin">
          <li>
            <div className="events__table list--striped bg-dark--1">
              {events.map((event, index) => (
                <ShowItem key={index} event={event} />
              ))}
            </div>
          </li>
        
          <li>
            <div className="events__table list--striped bg-dark--1">
              {pastEvents.map((event, index) => (
                <ShowItem key={index} event={event} />
              ))}
            </div>
          </li>
        </ul>
      </div>
    </section>
  );
};

export default EventList;
